import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Rotas} from "src/app/core/rotas";
import {BaseService} from "../base/base.service";
import {AcaoExecutada} from "../../core/acao-executada";

@Injectable({
    providedIn: "root",
})
export class AcaoExecutadaService extends BaseService<AcaoExecutada> {
    constructor(http: HttpClient) {
        super(http, Rotas.ACAO_EXECUTADA);
    }

    getFilter(descricao: string, idAtividade: number, idAcao: number) {
        const params: any = {};
        if (descricao) params.descricao = descricao;
        if (idAtividade) params.idAtividade = idAtividade;
        if (idAcao) params.idAcao = idAcao;
        return this.http.get(Rotas.ACAO_EXECUTADA + "filter", {params});
    }
}
